import { Route } from 'react-router-dom';

import { createLazyRoute } from '../routes/utils/createLazyRoute';

import { DEV_EXPERIMENTS } from './experiments';

/**
 * 개발용 실험 페이지 라우트 (/dev). 인증 불필요.
 *
 * 함수로 export하는 이유: 모듈 최상위에서 JSX를 생성하지 않아 side-effect-free가 되므로,
 * routes/index.tsx에서 `VITE_ENABLE_DEV_PAGES`가 꺼진 채 빌드하면 Rollup이 이 모듈과
 * 하위 실험 페이지 청크를 통째로 tree-shaking 한다(프로덕션 번들에서 완전 제외).
 */
export const getDevRoutes = () => (
  <Route path="dev">
    <Route index {...createLazyRoute(() => import('./DevIndexPage'))} />
    {DEV_EXPERIMENTS.map((exp) => (
      <Route key={exp.path} path={exp.path} {...createLazyRoute(exp.load)} />
    ))}
  </Route>
);
